import { createStyles, Stack } from '@mantine/core';
import { Text } from '@repo/foundations';

const useStyles = createStyles((theme) => ({
	wrapper: {
		borderRadius: theme.radius.md,
		border: `solid ${theme.other.borderWidth.sm}px ${theme.other.getColor('border/critical-secondary/default')}`,
	},
}));

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function ChartBlockErrorFallback({ error }: { error: Error }) {
	const { classes } = useStyles();

	return (
		<Stack className={classes.wrapper} spacing="sm" py="md" px="md">
			<Text size="sm" fw={600}>
				Unhandled error
			</Text>
			<Text size="sm" color="text/critical/default">
				There was an error while loading this chart.
			</Text>
		</Stack>
	);
}
